import { render, staticRenderFns } from "./OfferDelivery.vue?vue&type=template&id=f1aa80e2&scoped=true"
import script from "./OfferDelivery.vue?vue&type=script&lang=ts"
export * from "./OfferDelivery.vue?vue&type=script&lang=ts"
import style0 from "./OfferDelivery.vue?vue&type=style&index=0&id=f1aa80e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aa80e2",
  null
  
)

export default component.exports